import { TableCell, MenuItem, Select, Box } from "@mui/material";
import { FilterList } from "@mui/icons-material";
import React from "react";

export function CategoryLabels({ typeFilter, setTypeFilter, subFilter, setSubFilter }) {
  return (
    <>
      {/* 1. Tipo (Coleção) - Posição alterada para a 1ª Coluna com filtro */}
      <TableCell align="left" style={{ padding: "12px 16px", backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontWeight: "700", color: "#1e293b", fontSize: "0.88rem" }}>Tipo</span>
          <Box style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#ffffff", padding: "2px 6px", borderRadius: "6px", border: "1px solid #cbd5e1" }}>
            <FilterList style={{ fontSize: "16px", color: "#0284c7" }} />
            <Select
              size="small"
              variant="standard"
              disableUnderline
              value={typeFilter || "all"}
              onChange={(e) => setTypeFilter(e.target.value)}
              style={{
                fontSize: "0.78rem",
                color: "#0284c7",
                fontWeight: "700",
                cursor: "pointer"
              }}
            >
              <MenuItem value="all">Todos os Tipos</MenuItem>
              <MenuItem value="connectroutes">ConnectRoutes</MenuItem>
              <MenuItem value="connectstores">ConnectStores</MenuItem>
              <MenuItem value="connectplaces">ConnectPlaces</MenuItem>
              <MenuItem value="connectguides">ConnectGuides</MenuItem>
              <MenuItem value="connectsales">ConnectSales</MenuItem>
              <MenuItem value="connectmarket">ConnectMarket</MenuItem>
            </Select>
          </Box>
        </Box>
      </TableCell>

      {/* 2. Categoria - Palavra "Nome" trocada por "Categoria" e posição alterada para 2ª Coluna */}
      <TableCell align="left" style={{ padding: "12px 16px", backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
        <span style={{ fontWeight: "700", color: "#1e293b", fontSize: "0.88rem" }}>Categoria</span>
      </TableCell>

      {/* 3. Subcategorias - Com filtro por presença de subs */}
      <TableCell align="left" style={{ padding: "12px 16px", backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontWeight: "700", color: "#1e293b", fontSize: "0.88rem" }}>Subcategorias</span>
          <Box style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#ffffff", padding: "2px 6px", borderRadius: "6px", border: "1px solid #cbd5e1" }}>
            <FilterList style={{ fontSize: "16px", color: "#64748b" }} />
            <Select
              size="small"
              variant="standard"
              disableUnderline
              value={subFilter || "all"}
              onChange={(e) => setSubFilter(e.target.value)}
              style={{
                fontSize: "0.78rem",
                color: "#475569",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              <MenuItem value="all">Todas</MenuItem>
              <MenuItem value="with_subs">Com subs</MenuItem>
              <MenuItem value="no_subs">Sem subs</MenuItem>
            </Select>
          </Box>
        </Box>
      </TableCell>

      {/* 4. Editar */}
      <TableCell align="right" style={{ padding: "12px 16px", backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0", width: "60px" }}>
        <span style={{ fontWeight: "700", color: "#1e293b", fontSize: "0.88rem" }}>Editar</span>
      </TableCell>

      {/* 5. Excluir */}
      <TableCell align="right" style={{ padding: "12px 16px", backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0", width: "50px" }}>
        <span style={{ fontWeight: "700", color: "#1e293b", fontSize: "0.88rem" }}>Excluir</span>
      </TableCell>
    </>
  );
}
